interface BombIconProps {
  size?: number;
}

export function BombIcon({ size = 24 }: BombIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M14.5 4.5c1.2-.8 2.6-1 3.8-.6M16 3l2.5-1.5M16 3l1 2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10.5" cy="14" r="6.5" fill="currentColor" />
      <path
        d="M8 12.5c.8-1.2 2-2 3.5-2s2.7.8 3.5 2"
        stroke="#0f1115"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <circle cx="8.5" cy="12" r="0.75" fill="#0f1115" />
      <circle cx="12.5" cy="12" r="0.75" fill="#0f1115" />
    </svg>
  );
}
